import { defineStore } from 'pinia'
import { useMutation } from '@vue/apollo-composable'
import {
  postCreateEmailUserAlias as postCreateEmailUserAliasMutation,
  postIdentifyEmailUser as postIdentifyEmailUserMutation,
  postTrackEmailUser as postTrackEmailUserMutation
} from '@/queries'

import { sentryCapture } from '@/utils/sentry'

export const useBrazeStore = defineStore('BrazeStore', () => {
  const { mutate: trackEmailUser, onError: onTrackEmailError } = useMutation(postTrackEmailUserMutation)
  const { mutate: postIdentifyEmailUser, onError: onIdentifyError } = useMutation(postIdentifyEmailUserMutation)
  const { mutate: createEmailUserAlias, onError: onCreateAliasError } = useMutation(postCreateEmailUserAliasMutation)

  onTrackEmailError(err => sentryCapture(err))
  onIdentifyError(err => sentryCapture(err))
  onCreateAliasError(err => sentryCapture(err))

  return {
    trackEmailUser,
    createEmailUserAlias,
    postIdentifyEmailUser
  }
})
